import CryptoJS from 'crypto-js';
const getCryptoDecryptedCookie = (encodedUserCookieString) => {
    var _a;
    const decryptedData = (_a = process.env.PB_COOKIE_DECODE_KEY) === null || _a === void 0 ? void 0 : _a.toString();
    const data = CryptoJS.AES.decrypt({
        ciphertext: CryptoJS.enc.Hex.parse(encodedUserCookieString.substring(32)),
    }, CryptoJS.enc.Hex.parse(CryptoJS.SHA1(decryptedData).toString().substring(0, 32)), {
        iv: CryptoJS.enc.Hex.parse(encodedUserCookieString.substring(0, 32)),
    });
    return data.toString(CryptoJS.enc.Utf8);
};
/**
 * Get stored value from cookie, automatically decodes encoded cookie value.
 * @returns {(string|null)} - data from cookie or null if cookie does not exist
 */
const getPbCookie = () => {
    var _a;
    const encodedUserCookieString = (_a = window === null || window === void 0 ? void 0 : window.Cookies) === null || _a === void 0 ? void 0 : _a.get('encodedUserCookie');
    if (encodedUserCookieString) {
        const decUserCookie = encodedUserCookieString.replace(/##/gi, '');
        return getCryptoDecryptedCookie(decUserCookie);
    }
    return null;
};
export default getPbCookie;
//# sourceMappingURL=getPbCookie.js.map